import { useQuery } from "react-query";
import axios from "axios";
import { useContext, useState, useRef, useEffect } from "react";
import "./sectionend.scss";
import Loader from "../components/loader";
import LoadError from "../components/error";
import { ApiEndpoint, startNewSection } from "../components/utils";
import { pageIds } from "../components/utils";
import { AppDataContext, ctxDefinition } from "../components/ctx";
import AppHeader from "../components/appheader";
import { BrandButton } from "../components/form/buttons";
import { useNavigate } from "react-router-dom";
import NetworkError from "../components/networkError";

interface PageResponse {
  headerTitle?: string;
  welcomeMessage?: any;
  breakMessage?: any;
}

const SectionEnd = () => {
  const [gotoNextScreen, setGotoNextScreen] = useState(false);
  const navigate = useNavigate();
  const showTimer = useRef(false);
  let interval: any = null;
  const [seconds, setSeconds] = useState("00");
  const [minutes, setMinutes] = useState("0");
  const secondsRemainig = useRef(0);
  const [hasError, setHasError] = useState(false);
  const {
    userData,
    setUserData,
    setExamStartTime,
    config,
    fetchSectionQuestions,
  } = useContext(AppDataContext) as ctxDefinition;
  const [data, setdata] = useState<PageResponse | null>();
  const { isLoading, error } = useQuery("registerPageData", async () => {
    const resp = await axios.get(
      ApiEndpoint +
        "wp-json/firstchoiceprep/v1/getPageText?slug=" +
        pageIds.section_end
    );
    setdata(resp.data as PageResponse);
  });

  showTimer.current =
    config.breakTime[userData.currentSectionId] !== 0 ? true : false;

  const continueNextSection = async () => {
    setExamStartTime(new Date().getTime());
    const tempData = startNewSection(userData);
    updateServerProfile(tempData);
    setUserData(tempData);

    // Fetch all questions for the next section
    const nextSectionName = config.questionSections[tempData.currentSectionId];
    console.log(
      "Section End - Fetching questions for next section:",
      nextSectionName,
      "at index:",
      tempData.currentSectionId
    );
    const questions = await fetchSectionQuestions(
      tempData.token,
      nextSectionName
    );

    if (!questions) {
      console.error(
        "Section End - Failed to fetch questions for section:",
        nextSectionName
      );
      setHasError(true);
      return;
    }

    console.log(
      "Section End - Successfully fetched",
      questions.length,
      "questions"
    );
    setGotoNextScreen(true);
  };

  const startTimer = () => {
    let seconds = config.breakTime[userData.currentSectionId] / 1000;
    secondsRemainig.current = seconds;
    interval = setInterval(function () {
      setMinutes(Math.floor(seconds / 60).toString());
      const tempSeconds = seconds % 60;
      const formattedSeconds =
        tempSeconds < 10
          ? "0" + tempSeconds.toString()
          : tempSeconds.toString();
      setSeconds(formattedSeconds);
      seconds--;
      secondsRemainig.current = seconds;
      if (seconds <= -1) {
        clearInterval(interval);
      }
    }, 1000);
  };
  const updateServerProfile = async (uData: any) => {
    const resp = await axios.post(
      ApiEndpoint + "wp-json/firstchoiceprep/v1/updateUserData",
      {
        token: userData.token,
        fields: ["sectionStartTime"],
        values: [uData.sectionStartTime],
      }
    );
    if (!resp || !resp.data.success) {
      setHasError(true);
      return;
    }
  };

  const resetSectionTimer = async () => {
    const resp = await axios.post(
      ApiEndpoint + "wp-json/firstchoiceprep/v1/updateUserData",
      {
        token: userData.token,
        fields: ["sectionStartTime"],
        values: [null],
      }
    );
    if (!resp || !resp.data.success) {
      setHasError(true);
      return;
    }

    const temp = userData;
    temp.sectionStartTime = null;
    setUserData(temp);
  };

  useEffect(() => {
    if (gotoNextScreen) {
      navigate("/question/" + userData.lastQuestionAnswered, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gotoNextScreen]);

  useEffect(() => {
    resetSectionTimer();
    if (showTimer.current) startTimer();
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) return <Loader />;
  if (error) return <LoadError />;

  return (
    <div className="sectionEndPage">
      <div className="headerHolder">
        <AppHeader />
      </div>
      <div className="pageHeader">
        <h1>{data?.headerTitle}</h1>
      </div>
      <div className="pageContent">
        {secondsRemainig.current >= 0 ? (
          <div>
            <div dangerouslySetInnerHTML={{ __html: data?.breakMessage }} />
            <div className="timerHolder">
              {" "}
              {minutes}:{seconds} Minutes {}
            </div>
          </div>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: data?.welcomeMessage }} />
        )}
        <div className="btnHolder">
          <BrandButton
            disabled={secondsRemainig.current >= 0}
            onClick={continueNextSection}
          >
            Continue
          </BrandButton>
        </div>
      </div>
      <NetworkError open={hasError} />
    </div>
  );
};

export default SectionEnd;
